import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_ENDPOINT}/api/auth/login`;

const login = async (username, password) => {
  // old login function
  return axios
    .post(API_URL, {
      username,
      password,
    })
    .then((response) => {
      if (response.data.status.code === 'SUCCESS') {
        localStorage.setItem("user", JSON.stringify(response.data.data));
        if (response.data.data && response.data.data.room && response.data.data.room.id) {
          localStorage.setItem("roomId", response.data.data.room.id);
        }
        if (response.data.data && response.data.data.domain) {
          let features = response.data.data.domain.features
          if (response.data.data.domain.features === null || response.data.data.domain.features == [] || response.data.data.domain.features == '') {
            features = ['homeroom', 'friendship', 'pocket-book','riasec']
          }
          localStorage.setItem("features", features);
        }
        localStorage.setItem("access_token", JSON.stringify(response.headers.authorization));
        setLoginDate();
      }
      return response.data.data;
    });
};

const logout = () => {
  // localStorage.removeItem("user");
  // localStorage.removeItem("access_token");
  window.localStorage.clear();
};

// เดิมเก็บวันที่ล็อกอินเป็น new Date().getDate() (1-31) ทำให้วันที่ตรงกัน
// ข้ามเดือน (เช่น login 13 ก.ย. กลับมา 13 ต.ค.) ไม่ถูกตัด session
// จึงเปลี่ยนมาเก็บเป็น YYYY-MM-DD เต็ม
const getTodayKey = () => {
  const d = new Date();
  const month = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  return `${d.getFullYear()}-${month}-${day}`;
};

const setLoginDate = () => {
  localStorage.setItem("date", getTodayKey());
};

const getLoginDate = () => {
  return localStorage.getItem("date");
};

const isLoginDateStale = () => {
  const saved = getLoginDate();
  // ยังไม่เคย login -> ไม่ต้องตัด
  if (!saved) return false;
  // ค่าเก่าที่เก็บเป็นเลขวันที่ล้วนจะไม่ตรงกับรูปแบบใหม่
  // ผู้ใช้ที่ค้างอยู่จะถูกขอให้ login ใหม่หนึ่งครั้งหลัง deploy
  return saved !== getTodayKey();
};

const getCurrentUser = () => {
  if (localStorage.getItem("user")) {
    return JSON.parse(localStorage.getItem("user"));
  }
  return null
};

const getCurrentUserId = () => {
  if (localStorage.getItem("user")) {
    const user = JSON.parse(localStorage.getItem("user"));
    return user.id;
  }
  return 0
};


const getCurrentUserFeatures = () => {
  if (localStorage.getItem("features")) {
    const features = localStorage.getItem("features");
    if (features) {
      return features.split(',')
    }
    return [];
  }
  return 0
};

const getUserFullName = () => {
  if (localStorage.getItem("user")) {
    const user = JSON.parse(localStorage.getItem("user"));
    return user.fullName;
  }
  return ''
};

const getUserRole = () => {
  if (localStorage.getItem("user")) {
    const user = JSON.parse(localStorage.getItem("user"));
    return user.roles[0].toLowerCase();
  }
  return ''
};

const getUserCurrentTerm = () => {
  if (localStorage.getItem("user")) {
    const user = JSON.parse(localStorage.getItem("user"));
    if(typeof user.room !== 'undefined'){
      return user.room.term;
    }
  }
  return ''
};

const getUserCurrentYear = () => {
  if (localStorage.getItem("user")) {
    const user = JSON.parse(localStorage.getItem("user"));

    if(typeof user.room !== 'undefined'){
      return user.room.year;
    }
    
  }
  return ''
};

const getCurrentRoomId = () => {
  if (localStorage.getItem("user")) {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user.room && user.room.id) {
      return user.room.id;
    }
  }
  return ''
};

const getComputeRoomId = () => {
  if (localStorage.getItem("roomId")) {
    return localStorage.getItem("roomId");
  } else if (localStorage.getItem("user")) {
    const user = JSON.parse(localStorage.getItem("user"));
    return user.room.id;
  }
  return ''
};

const setComputeRoomId = (roomId) => {
  if (roomId) {
    localStorage.setItem("roomId", roomId);
  }
  return roomId
};

// const config = {
//   headers: { Authorization: `Bearer ${token}` }
// };

// const bodyParameters = {
//  key: "value"
// };

// Axios.post( 
// 'http://localhost:8000/api/v1/get_token_payloads',
// bodyParameters,
// config
// ).then(console.log).catch(console.log);

export default {logout, getCurrentUser,
  getUserFullName, getUserRole, getCurrentUserId,
  getUserCurrentTerm, getUserCurrentYear, getCurrentRoomId,
  setComputeRoomId, getComputeRoomId,getLoginDate, getCurrentUserFeatures,
  setLoginDate, isLoginDateStale, getTodayKey};
